import { loadChurnkey } from './churnkey';
import { waitForStripe } from './stripe';

/**
 * Shows the Churnkey failed payment wall to customers with an overdue invoice.
 *
 * The config is rendered server side by `components/churnkey-payment-wall.blade.php`
 * and is only present for customers the `useChurnkeyPaymentWall` gate allows.
 */
export const initChurnkeyPaymentWall = async () => {
  const paymentWall = window.__churnkeyPaymentWall;

  if (!paymentWall?.config) {
    return;
  }

  const { config, organisationId } = paymentWall;

  try {
    // Churnkey builds its card form with window.Stripe, and throws if it is not
    // there yet, so both scripts have to be ready before the wall is checked.
    await Promise.all([
      loadChurnkey(config.appId),
      waitForStripe(),
    ]);
  } catch (error) {
    console.error('Failed to initialise the Churnkey payment wall:', error);
    return;
  }

  window.churnkey.check('failed-payment', {
    ...config,
    onFailedPaymentWallActivated: () => {
      window.mixpanel('Churnkey: View payment wall', { organisation_id: organisationId });
    },
    onUpdatePaymentInformation: () => {
      window.mixpanel('Churnkey: Payment wall card updated', { organisation_id: organisationId });
    },
    onFailedPaymentWallClose: () => {
      window.mixpanel('Churnkey: Payment wall dismissed', { organisation_id: organisationId });
    },
    onError: (error, type) => {
      console.error('Payment wall error:', type, error);
    },
  });
};
